<template>
  <div
    class="video-container"
    :data-url="url"
    :data-thumbnailUrl="thumbnailUrl"
    :data-status="status"
    :data-attachmentId="attachmentId"
    :data-duration="duration"
    :data-filename="filename"
  >
    <!-- pc端视频播放 s -->
    <section :style="videoWarpStyle" v-show="env === 'web'">
        <video
          v-show="!showCover && status == 'ProcessSuccess'"
          class="video-player"
          x5-video-player-type="h5-page"
          controls
          :preload="env === 'web' ? 'auto':'none'"
          controlslist="nodownload noremoteplayback"
          disablePictureInPicture
          ref="video"
          :src="url"
          :poster="thumbnailUrl"
          @play="onPlay"
          @pause="onStop"
          @ended="onStop"
        >
        </video>
        <!-- 视频的所有状态都显示视频封面图，当点击播放后如果是转码成功就展示视频，否则展示封面图 -->
        <img v-show="showCover" :src="thumbnailUrl" alt="封面图" class="video-player" />
    </section>
    <!-- pc端视频播放 e -->
    <!-- 患者端客户端走这个逻辑 直接跳客户端页面播放 s -->
    <a v-show="!enableJsbridge && env === 'app'" :href="videoScheme">
        <img :src="thumbnailUrl" alt="视频封面图" class="video-player" />
        <section v-show="!isPlaying" class="play-icon">
          <svg-icon class="paly-icon-svg" name="play_video"></svg-icon>
        </section>
    </a>
    <!-- 患者端客户端走这个逻辑 直接跳客户端页面播放 s -->
    <!-- 医生版本客户端走这个逻辑 jsbridge s-->
    <section v-show="enableJsbridge && env === 'app'" @click.stop="handlePlay">
        <img :src="thumbnailUrl" alt="视频封面图" class="video-player" />
    </section>
     <!-- 医生版本客户端走这个逻辑 jsbridge end-->
    <!-- 视频的播放按钮 s -->
    <section v-show="enableJsbridge && !isPlaying" class="play-icon" @click="handlePlay">
      <svg-icon class="paly-icon-svg" name="play_video"></svg-icon>
    </section>
    <!-- 视频的播放按钮 end -->
    <!-- 视频时长s -->
    <section v-show="!isPlaying && duration && durationText" :class="env === 'web' ? 'durationWeb' : 'durationApp' ">
      <div>视频时长：{{durationText}}</div>
    </section>
    <!-- 视频时长end -->
  </div>
</template>
<script>
import toast from '@hb/hb-toast';
import jsBridge from '@hb/hb-jsbridge';
export default {
  props: {
    // 当前环境
    env: {
      type: String,
      default: 'web'
    },
    // 播放视频的方式
    enableJsbridge: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      url: '', // 视频播放源
      thumbnailUrl: '', // 视频封面图
      isPlaying: false, // 是否在播放视频
      attachmentId: '', // 附件id
      status: '', // 视频的状态
      showCover: true, // 是否展示封面图
      videoWarpStyle: {
        'text-align': 'center',
        background: '#000'
      }

    };
  },
  computed: {
    durationText() {
      const durationNum = parseInt(this.duration);
      const durationHour = Math.floor(durationNum / (60 * 60));
      const durationMinute = Math.floor(durationNum % (60 * 60) / 60);
      const durationSecond = durationNum % 60;
      const durationHourText = durationHour > 0 ? durationHour + '时' : '';
      const durationMinuteText = durationMinute > 0 ? durationMinute + '分' : '';
      return `${durationHourText}${durationMinuteText}${durationSecond}秒`;
    },
    // 客户端播放页面地址
    videoScheme() {
      return `hdf://knowledge/haodfWebVideoPlay?videoURL=${encodeURIComponent(this.url)}&coverURL=${encodeURIComponent(this.thumbnailUrl)}`;
    }
  },
  methods: {
    // pc播放视频
    onPlay() {
      const audioAndVideoArr = Array.from(document.querySelectorAll('audio, video'));
      audioAndVideoArr.forEach((item) => {
        if (!item.paused && item !== this.$refs.video) {
          item.pause();
        }
      });
      this.toggleIsPlaying(true);
    },
    // pc停止/暂停播放视频
    onStop() {
      this.toggleIsPlaying(false);
    },
    // 新版本客户端播放视频点击事件
    handlePlay() {
      this.env === 'app' ? this.onPlayInApp() : this.onPlayInHtml();
    },
    // 客户端播放视频
    onPlayInApp() {
      // 关闭所有音频
      const audioList = Array.from(document.querySelectorAll('audio'));
      audioList.forEach((item) => { !item.paused && item.pause(); });
      const data = {
        videoUrl: this.url,
        coverUrl: this.thumbnailUrl
      };
      jsBridge.callCHandler({
        nativeMethod: 'onVideoPreview',
        data
      });
    },
    // pc/touch播放视频
    onPlayInHtml() {
      if (this.status === 'ProcessSuccess') {
        this.showCover = false;
        this.$refs.video && this.$refs.video.play();
      } else {
        toast.inform('视频转码中，刷新页面重试');
      }
    },
    // 设置播放的状态
    toggleIsPlaying(isPlaying) {
      this.isPlaying = isPlaying;
    }
  }
};
</script>
<style lang="scss">
  @import "./index.scss";
</style>
